import React from "react";
import ArenkoThemeProvider from "@arenko-group/arenko-ui/dist/theme/ArenkoThemeProvider";
import { useOfflineNotification } from "@/hooks/useOfflineNotification";
import CubeProvider from "./CubeProvider";
import LazyRouterProvider from "./LazyRouterProvider";

const NimbusGlobalProvider = () => {
  useOfflineNotification();

  return (
    <CubeProvider>
      <ArenkoThemeProvider brandName="nimbusApp" withContainer={false}>
        <LazyRouterProvider />
      </ArenkoThemeProvider>
    </CubeProvider>
  );
};

export default NimbusGlobalProvider;
